import React from "react";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenuNew";
import { useIntl } from "react-intl";

export default function XLinkDropDown({
  link,
  setLink,
  options,
  totalSelectedLinkAmount,
  setTotalSelectedLinkAmount,
}) {
  const { formatMessage } = useIntl();

  return (
    <>
      <PopperMenu
        type="filter"
        anchorAlign={"end"}
        selectedItems={link}
        setSelectedItems={setLink}
        totalSelectedAmount={totalSelectedLinkAmount}
        setTotalSelectedAmount={setTotalSelectedLinkAmount}
        menuListTitle={formatMessage({ id: "global.filter.filter" })}
        showMenuListTitle={true}
        menuTitleButton={formatMessage({ id: "global.btn.clearAll" })}
        onMenuTitleButtonClick={() => setLink({})}
        filterText={formatMessage({ id: "global.filter.filter" })}
        menuItemGroup={[
          {
            menuItemId: "links",
            menuItemTitle: formatMessage({
              id: "global.filterCriteria.postLinks",
            }),
            menuItems: options.map((item) => ({
              value: item.value,
              label: item.label,
            })),
            canMultiSelect: false,
            onClick: (selected) => console.log("KOL Selected:", selected),
          },
        ]}
      />
    </>
  );
}
